import { render, staticRenderFns } from "./ChoiceBreadcrumbs.vue?vue&type=template&id=11cb22a8&scoped=true"
import script from "./ChoiceBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ChoiceBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb22a8",
  null
  
)

export default component.exports